export const ActionTypes = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  MULTIPLEDELETE: 'MULTIPLEDELETE',
  MULTIPLEUPDATE: 'MULTIPLEUPDATE',
  UPDATEALL: 'UPDATEALL',
  UNDO: 'UNDO',
  REPEAT: 'REPEAT',
  MULTIPLEREPEAT: 'MULTIPLEREPEAT',
};
export const Layouts = [
  { id: 1, name: 'Sequential' },
  { id: 2, name: 'Shuffle' },
];
export const BlockTypes = [
  { id: 1, name: 'Movies' },
  { id: 2, name: 'Placeholder' },
  { id: 3, name: 'Series' },
  { id: 4, name: 'Title Group' },
  { id: 5, name: 'Repeat' },
];

export const defaultModalState = {
  disableGenre: false,
  disableMaxCount: false,
  disableAvailableDuration: false,
  disableSeason: false,
  disableSeries: false,
  disableTitleGroup: false,
  disableLayout: false,
  disableSequential: false,
  disableStartTime: false,
  disableEndTime: false,
  disableLinkReference: false,
  disableType: false,
  disableDayOfWeek: false,
  disableReccurrence: false,
  disableLinkToggle: false,
  disablePlacement: false,
  type: 'Movies',
  genre: '',
  programMaxCount: null,
  programAvailableDuration: null,
  series: null,
  seasons: null,
  titleGroup: null,
  weekNumber: 1,
  dayOfWeek: { id: 1, name: 'Monday' },
  startTime: new Date(),
  endTime: new Date(),
  hasLink: false,
  layout: '',
  linkReference: null,
  sequential: false,
  errorMessage: '',
};

export const daysAbbreviation = [
  'Mon',
  'Tue',
  'Wed',
  'Thu',
  'Fri',
  'Sat',
  'Sun',
];

export const ProgramTypes = {
  MOVIES: 'Movies',
  PLACEHOLDER: 'Placeholder',
  SERIES: 'Series',
  TITLEGROUP: 'Title Group',
  REPEAT: 'Repeat',
};

export const RECURRENCE_DAYS = [
  { id: 1, name: 'Monday' },
  { id: 2, name: 'Tuesday' },
  { id: 3, name: 'Wednesday' },
  { id: 4, name: 'Thursday' },
  { id: 5, name: 'Friday' },
  { id: 6, name: 'Saturday' },
  { id: 7, name: 'Sunday' },
];

export const RECURRENCE_PATTERN = {
  STRIP: 1,
  STACK: 2,
};

export const RECURRENCE_PATTERN_LIST = [
  { id: RECURRENCE_PATTERN.STRIP, name: 'Strip' },
  { id: RECURRENCE_PATTERN.STACK, name: 'Stack' },
];
